export const getNormalizedPrice = (value: any) => {
    const minimizedValue = Number(value) / 100
    const normalized = minimizedValue.toFixed(2)
    return normalized
}